export default __webpack_public_path__ + "static/recalibrate-ceef0ed19d5cdcd2702610731b23e749.jpg";